/*
NOTE - I'm manually adding "uid" : 'newProject_033447314346123447',
*/

const example_project_template = {
    "uid" : 'newProject_033447314346123447',
    "card_data" : {
      "newCard_007199607391890717" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 139, 92 ],
        "size" : [ 393, 316 ],
        "synopsis" : "This App is designed to help you with constructing and visualising your stories in a novel and intuitive way.\n\nThis is a card. It can be thought of in the same way you might use an index card on a corkboard.",
        "title" : "Welcome to StoryCraft."
      },
      "newCard_019389615284175865" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 997, 631 ],
        "size" : [ 334, 246 ],
        "synopsis" : "Cards can be linked with Threads. These allow you to plot a line through your story, branch off into sub plots, or define relationships between cards.\nTo link cards, drag from the top centre of a card onto another.\n\nThreads can be filtered for in Writing Mode.\n\nThread colour can be changed via the pencil icon on the top right.",
        "title" : "<-- Threads"
      },
      "newCard_03258198610110641" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 1017, 358 ],
        "size" : [ 294, 196 ],
        "synopsis" : "Drag and drop this card onto Chapter 2.\nYou will notice a number appear in the corner. Click on that number to dive into Chapter 2's cards.",
        "title" : "<-- Drag Me "
      },
      "newCard_03258811463070086" : {
        "item_parent" : "project_newProject_033447314346123447",
        "links" : {
          "document" : [ "newDoc_05974309892921954" ]
        },
        "pos" : [ 617, 589 ],
        "size" : [ 294, 196 ],
        "synopsis" : "This field is for a synopsis, or brief summary of the main idea of the card.\n\nFor more detail, create a document by clicking 'Add New Document' in the attribute editor. Once created, a document icon will appear on the card.",
        "title" : "Chapter 3"
      },
      "newCard_04153155300816722" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 617, 98 ],
        "size" : [ 294, 196 ],
        "synopsis" : "A Card might represent a chapter of your story.\n\n",
        "title" : "Chapter 1"
      },
      "newCard_0425303907809252" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 617, 348 ],
        "size" : [ 294, 196 ],
        "synopsis" : "Cards can be nested within other cards.",
        "title" : "Chapter 2"
      },
      "newCard_05757070816894663" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 1568, 488 ],
        "size" : [ 294, 196 ],
        "synopsis" : "On the right side of the screen is the attribute editor. It contains everything you need fo editing you items. \n\n",
        "title" : "Attribute editor -->"
      },
      "newCard_05775518323754918" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 1021, 95 ],
        "size" : [ 294, 196 ],
        "synopsis" : "It could be simply an idea you want to come back to later",
        "title" : "An Idea!"
      },
      "newCard_0627266692351206" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 618, 828 ],
        "size" : [ 294, 196 ],
        "synopsis" : "Cards can be added to the timeline by clicking the 'Add to Timeline' button in the attribute editor. \n\nOnce cards have been added, that button will change to 'Go to Timleine', and a time icon will appear on the card.\n",
        "time" : {
          "_time_progress" : {
            "row" : 1,
            "start_end_time" : [ 5, 15 ]
          }
        },
        "title" : "Chapter 4"
      },
      "newCard_09623383972015598" : {
        "item_parent" : "project_newProject_033447314346123447",
        "pos" : [ 138, 480 ],
        "size" : [ 382, 236 ],
        "synopsis" : "This App is very much under construction.\nThere are some features that are working, others that may not work at, and others that are simply blocked in but need a lot more work.\n\n",
        "title" : "NOTE!"
      }
    },
    "character_data" : {
      "character_05292156804935928" : {
        "age" : "",
        "description" : "Jimmy Pesto is Bob's nemasis. He runs the Italian restaurant across the road",
        "dob" : "",
        "icon" : "fas fa-user",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Fcharacter_data%2Fcharacter_05292156804935928?alt=media&token=bab9fb05-f2d2-4c7d-abfa-45153ffc400b",
        "itemSize" : "large",
        "name" : "Jimmy Pesto"
      },
      "character_06130337354045083" : {
        "age" : 42,
        "description" : "Bob runs a burger shop and has a wife and 3 kids",
        "dob" : "",
        "icon" : "fas fa-user",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Fcharacter_data%2Fcharacter_06130337354045083?alt=media&token=78176024-b8bb-4e1d-aa1e-56b0289378c2",
        "itemSize" : "large",
        "links" : {
          "prop" : [ "prop_09184543325781935" ]
        },
        "name" : "Bob"
      },
      "character_07815015693156007" : {
        "age" : 12,
        "description" : "Tina is Bobs daughter. She likes horses and is going through a very awkward puberty.",
        "dob" : "",
        "icon" : "fas fa-user",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Fcharacter_data%2Fcharacter_07815015693156007?alt=media&token=dd316b21-0883-4a7c-b462-a79e66c9df68",
        "itemSize" : "large",
        "name" : "Tina"
      }
    },
    "created_by" : "",
    "creation_date" : "",
    "description" : "",
    "document_data" : {
      "newDoc_05974309892921954" : {
        "synopsis" : "",
        "text" : "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget. Sit amet porttitor eget dolor morbi non arcu risus quis. Ultrices vitae auctor eu augue ut lectus arcu bibendum at. Pellentesque elit ullamcorper dignissim cras. At in tellus integer feugiat scelerisque varius morbi. Id neque aliquam vestibulum morbi blandit cursus risus at ultrices. Placerat orci nulla pellentesque dignissim enim sit amet. Posuere morbi leo urna molestie at elementum eu facilisis sed. At imperdiet dui accumsan sit amet. Bibendum ut tristique et egestas quis ipsum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. Rhoncus aenean vel elit scelerisque mauris. Facilisis volutpat est velit egestas dui id. A diam maecenas sed enim ut sem viverra aliquet eget. Et netus et malesuada fames ac. Gravida quis blandit turpis cursus in. Vulputate enim nulla aliquet porttitor lacus.</p><p>Sed blandit libero volutpat sed cras ornare arcu dui vivamus. Bibendum arcu vitae elementum curabitur vitae nunc sed velit. Sit amet luctus venenatis lectus magna fringilla urna porttitor. Pretium fusce id velit ut tortor pretium viverra suspendisse potenti. Mauris rhoncus aenean vel elit scelerisque mauris pellentesque pulvinar. Ornare arcu odio ut sem nulla pharetra diam sit amet. Tristique sollicitudin nibh sit amet commodo nulla facilisi. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt. Accumsan tortor posuere ac ut consequat. Eget dolor morbi non arcu risus quis varius quam quisque.</p><p>Aliquet nibh praesent tristique magna sit amet. Eu feugiat pretium nibh ipsum consequat nisl vel pretium lectus. Nulla malesuada pellentesque elit eget gravida. Amet venenatis urna cursus eget. Id faucibus nisl tincidunt eget nullam. Dictum varius duis at consectetur lorem donec massa. In ornare quam viverra orci sagittis eu volutpat odio facilisis. In vitae turpis massa sed elementum tempus egestas. Nunc faucibus a pellentesque sit. Eget gravida cum sociis natoque. Tincidunt dui ut ornare lectus sit. In eu mi bibendum neque. Eget felis eget nunc lobortis mattis aliquam. Sed augue lacus viverra vitae congue eu consequat ac felis. Diam volutpat commodo sed egestas egestas fringilla phasellus faucibus scelerisque. At urna condimentum mattis pellentesque id. Neque aliquam vestibulum morbi blandit.</p><p>Etiam tempor orci eu lobortis elementum. Ac turpis egestas maecenas pharetra convallis posuere morbi leo. Dictum sit amet justo donec enim diam. Venenatis urna cursus eget nunc. Sit amet facilisis magna etiam tempor orci eu lobortis elementum. Quis viverra nibh cras pulvinar mattis. Sem nulla pharetra diam sit amet nisl suscipit. Velit ut tortor pretium viverra suspendisse potenti nullam ac tortor. Quisque id diam vel quam elementum pulvinar etiam non quam. Et odio pellentesque diam volutpat commodo sed. Aliquet nibh praesent tristique magna sit. Lorem ipsum dolor sit amet. Nibh cras pulvinar mattis nunc sed blandit libero volutpat. Fusce ut placerat orci nulla pellentesque dignissim. Magna eget est lorem ipsum dolor. Odio morbi quis commodo odio aenean sed. Lacus viverra vitae congue eu consequat ac felis donec.</p><p>Lectus magna fringilla urna porttitor rhoncus dolor purus non. Tortor at auctor urna nunc id cursus metus aliquam. Turpis massa sed elementum tempus. Eu facilisis sed odio morbi quis commodo odio. Ac ut consequat semper viverra nam libero justo laoreet sit. Senectus et netus et malesuada fames ac turpis egestas sed. Pulvinar neque laoreet suspendisse interdum consectetur. Turpis nunc eget lorem dolor sed viverra ipsum nunc aliquet. Bibendum at varius vel pharetra. Blandit cursus risus at ultrices mi tempus. Aliquet eget sit amet tellus cras adipiscing enim eu turpis. Feugiat in ante metus dictum at. Tristique senectus et netus et malesuada fames ac turpis egestas. At auctor urna nunc id cursus metus aliquam eleifend.</p>",
        "title" : ""
      }
    },
    "event_data" : {
      "event_08546669498848773" : {
        "color" : [ 255, 120, 203 ],
        "description" : "Bob finally confronts Jimmy Pesto. ",
        "icon" : "far fa-calendar-alt",
        "image" : "",
        "name" : "Bob confronts Jimmy",
        "opacity" : 0.5,
        "time" : {
          "_time_progress" : {
            "start_end_time" : [ 12, 12 ]
          }
        }
      }
    },
    "flow_viewport_data" : {
      "project_newProject_033447314346123447" : {
        "pos" : [ -28.030988800000017, -39.87526400000007 ],
        "scale" : 1.0616832
      }
    },
    "links" : {
      "card" : [ "newCard_007199607391890717", "newCard_04153155300816722", "newCard_05775518323754918", "newCard_0425303907809252", "newCard_03258198610110641", "newCard_05757070816894663", "newCard_0627266692351206", "newCard_03258811463070086", "newCard_019389615284175865", "newCard_09623383972015598" ],
      "character" : [ "character_06130337354045083", "character_07815015693156007", "character_05292156804935928" ],
      "event" : [ "event_08546669498848773" ],
      "flow_viewport" : [ "project_newProject_033447314346123447" ],
      "location" : [ "location_004536995067101768", "location_018386371838711746" ],
      "prop" : [ "prop_09184543325781935" ],
      "region" : [ "newRegion_04182179658284435" ]
    },
    "location_data" : {
      "location_004536995067101768" : {
        "description" : "This is where Bob lives and works. The burger joint is downstairs and they live upstairs.",
        "icon" : "fas fa-archway",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Flocation_data%2Flocation_004536995067101768?alt=media&token=c017144e-65a3-4555-b0a4-4203d981e6c3",
        "item_parent" : "topLevel",
        "name" : "Bob's House",
        "pos" : [ 461, 603 ]
      },
      "location_018386371838711746" : {
        "description" : "Jimmy Pesto's is an italian resaurant owned by Bob's nemasis, Jimmy Pesto",
        "icon" : "fas fa-archway",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Flocation_data%2Flocation_018386371838711746?alt=media&token=7b83fd66-88c7-4ad2-a3d0-44f36fdd625e",
        "item_parent" : "topLevel",
        "name" : "Jimmy Pesto's",
        "pos" : [ 888, 750 ]
      }
    },
    "map_viewport_data" : {
      "topLevel" : {
        "pos" : [ 1, -1 ],
        "scale" : 1
      }
    },
    "name" : "Example Project",
    "owner" : "",
    "parent_item" : "",
    "prop_data" : {
      "prop_09184543325781935" : {
        "description" : "This is Bob's lucky burger flipping spatula",
        "icon" : "fas fa-wrench",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Fprop_data%2Fprop_09184543325781935?alt=media&token=d6ff46c4-3dda-4b9d-8cee-ced77f095c00",
        "name" : "spatula"
      }
    },
    "region_data" : {
      "newRegion_04182179658284435" : {
        "color" : [ 50, 100, 200 ],
        "icon" : "far fa-sticky-note",
        "image" : "https://firebasestorage.googleapis.com/v0/b/avi-firebase-project.appspot.com/o/story_app_root_1%2Fregion_data%2FnewRegion_04182179658284435?alt=media&token=20689a17-2bd4-46db-bb06-eb38763fcb81",
        "item_parent" : "topLevel",
        "name" : "",
        "opacity" : 0.7,
        "pos" : [ 86, 57 ],
        "size" : [ 1208, 947 ]
      }
    },
    "thread_data" : {
      "col_uid1" : {
        "connections" : {
          "con_006105800330213551" : [ [ "card", "newCard_03258811463070086" ], [ "card", "newCard_0425303907809252" ] ],
          "con_041479045933748937" : [ [ "card", "newCard_04153155300816722" ], [ "card", "newCard_0425303907809252" ] ],
          "con_047242954922976743" : [ [ "card", "newCard_03258811463070086" ], [ "card", "newCard_0627266692351206" ] ]
        }
      }
    },
    "ui_data" : {
      "modal_data" : {
        "create_character" : {
          "age" : 12,
          "description" : "Jimmy Pesto is Bob's nemasis. He runs the Italian restaurant across the road",
          "name" : "Jimmy Pesto"
        },
        "create_event" : {
          "description" : "Bob finally confronts Jimmy Pesto. ",
          "name" : "Bob confronts Jimmy"
        },
        "create_location" : {
          "description" : "Jimmy Pesto's is an italian resaurant owned by Bob's nemasis, Jimmy Pesto",
          "name" : "Jimmy Pesto's"
        },
        "create_prop" : {
          "description" : "This is Bob's lucky burger flipping spatula",
          "name" : "spatula"
        }
      },
      "writing_panel_settings" : {
        "show_all_cards" : false
      }
    },
    "users" : {
      "RnUYt682ckcgBhajUATque6rUI53" : true
    }
  }
  

  export default example_project_template